import React, { useState } from "react";
import s from "./style.module.css";
import VideoEmbed from "../VideoEmbed";
import YoutubeEmbed from "../YoutubeEmbed";
import cn from "classnames";
import { ReactComponent as External } from "../Icons/external.svg";

const Video = ({
  embedID,
  title,
  description,
  type,
  copy,
  presentationTitle,
  presentationLink,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      {embedID && type !== "youtube" && <VideoEmbed id={embedID} />}
      {embedID && type === "youtube" && <YoutubeEmbed id={embedID} />}
      <div>
        {title && <span className={s.title}>{title}</span>}
        {presentationLink && presentationTitle && (
          <a
            className={s.presentationLink}
            href={presentationLink}
            target="_blank"
            rel="nooopener"
          >
            <External />
            {presentationTitle}
          </a>
        )}

        {description && (
          <span className={cn(s.description, { [s.isOpen]: isOpen })}>
            <span className={s.descriptionText}>{description}</span>

            <button onClick={() => setIsOpen(!isOpen)} className={s.readMore}>
              {isOpen ? copy.close : copy.readMore}
            </button>
          </span>
        )}
      </div>
    </div>
  );
};

const VideoList = ({ items = [], copy }) => {
  return (
    <div className={s.wrap}>
      {items.map((video) => (
        <Video key={video.embedID} {...video} copy={copy} />
      ))}
    </div>
  );
};

export default VideoList;
